// extracted by mini-css-extract-plugin
export default {"alfa":"GroupeEmail_alfa__YN6uw","btadd":"GroupeEmail_btadd__VhcHc","creer":"GroupeEmail_creer__hFeFm","comtnet":"GroupeEmail_comtnet__NOLu2","fontSize":"GroupeEmail_fontSize__hHnBE"};